// import React from "react";
// import Button from "../../component/ui/Button";

// const CTASection = () => {
//   return (
//     <div className="flex justify-center items-center w-full max-w-[806px] sm:max-w-[1209px] lg:max-w-[1612px]">
//       <div className="flex flex-col gap-[10px] sm:gap-[15px] lg:gap-[20px] justify-start items-center w-full h-auto bg-accent-green-light rounded-[25px] sm:rounded-[37px] lg:rounded-[50px] p-[27px] sm:p-[40px] lg:p-[54px]">
//         <h2 className="text-[30px] sm:text-[45px] lg:text-[60px] font-bold leading-[38px] sm:leading-[57px] lg:leading-[76px] text-center text-primary-background w-auto mt-[7px] sm:mt-[10px] lg:mt-[14px] font-[Sora]">
//           Partner with Us for Greener Farming
//         </h2>

//         <p className="text-[12px] sm:text-[18px] lg:text-[24px] font-normal leading-[19px] sm:leading-[28px] lg:leading-[38px] text-center text-primary-background w-full font-[Sora]">
//           At Govardhannathji Energies LLP, we believe in sustainable agriculture
//           that benefits both farmers and the environment. Our organic
//           fertilizers are designed to improve soil health and ensure bountiful
//           harvests without compromising ecological balance.
//         </p>

//         <Button
//           text="Learn More"
//           text_font_size="text-lg"
//           text_font_family="Sora"
//           text_font_weight="font-bold"
//           text_line_height="leading-base"
//           text_text_align="center"
//           text_color="text-white"
//           fill_background_color="bg-primary-background"
//           border_border_radius="rounded-lg"
//           padding="p-[6px_15px] sm:p-[9px_22px] lg:p-[12px_30px]"
//           className="w-auto hover:bg-primary-light transition-all duration-200"
//         />
//       </div>
//     </div>
//   );
// };

// export default CTASection;

import React from "react";
import CommonCTA from "../../component/common/CommonCTA";

const CTASection = () => {
  // Define specific button styles if needed, or leave empty to use defaults
  const handleLearnMore = () => {
    console.log("Navigate to learn more");
  };

  return (
    <>
      {/* 1. The Original Section (Recreated) */}
      <CommonCTA
        heading="Join the Renewable Energy Revolution"
        description=" At Govardhannathji Energies LLP, we are committed to transforming waste into valuable energy resources. Our bio gas solutions empower individuals, businesses, and communities to embrace sustainability and reduce their environmental impact."
        buttonText="Learn More"
        backgroundColor="#9FC46D"
        buttonProps={{
          onClick: handleLearnMore,
          // You can override colors here if needed
          fill_background_color: "#1C233A",
        }}
      />
    </>
  );
};

export default CTASection;
